import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BackPageService } from '@services/back-page/back-page.service';

@Injectable({ providedIn: 'root' })
export class CloseFormService {
    urlReturn;

    constructor(
        private router: Router,
        private backPageService: BackPageService,
    ) {}

    saveURL() {
        this.urlReturn = this.router.url;
    }

    closeForm(id) {
        if (this.urlReturn) {
            if (this.urlReturn.startsWith('/ins')) {
                this.urlReturn = `/patient/${
                    this.urlReturn.slice(5).split('/')[1]
                }`;
            }
            return this.router.navigate([this.urlReturn]);
        }
        if (!id) {
            return this.backPageService.goBackPage();
        }

        return this.router.navigate(['patient', id]);
    }
}
